import { Component, OnInit } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';

@Component({
  selector: 'app-partner-action-renderer',
  templateUrl: './partner-action-renderer.component.html',
  styleUrls: ['./partner-action-renderer.component.scss']
})
export class PartnerActionRendererComponent implements ICellRendererAngularComp {

  params: any;

  idString = 'partnerAction';

  constructor() { }

  agInit(params: any): void {
    this.params = params;
    this.idString = this.params.context.componentParent.idString;
  }

  handleActionClickEvent(action: string) {
    this.params.context.componentParent.handleActionClick(action, this.params.data);
  }

  refresh(): boolean {
    return false;
  }

}
